import React, { useState } from 'react';
import { Clock, Monitor, LogOut, Activity, Check, AlertTriangle } from 'lucide-react';

const SecuritySettingsModal = ({ setShowSecuritySettings, sessionTimeout, setSessionTimeout, loginHistory, logoutAllDevices, logoutDevice, securityLogs }) => (
    <div className="fixed inset-0 z-[300]" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div
        className="fixed bottom-0 left-0 right-0 bg-white rounded-t p-6"
        style={{ maxWidth: 448, margin: '0 auto', maxHeight: '90vh', overflowY: 'auto', WebkitOverflowScrolling: 'touch', zIndex: 301 }}
      >
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-bold text-[#282c3f]">Security & Privacy</h2>
          <button onClick={() => setShowSecuritySettings(false)} className="text-[#94969f]">
            ✕
          </button>
        </div>

        {/* Session Settings */}
        <div className="mb-6">
          <h3 className="font-semibold text-[#282c3f] mb-3 flex items-center gap-2">
            <Clock size={20} className="text-[#ff3f6c]" />
            Session Settings
          </h3>
          <div className="bg-gray-50 rounded p-4">
            <div className="flex justify-between items-center mb-2">
              <span className="text-sm text-[#535766]">Auto-logout timeout</span>
              <select
                value={sessionTimeout}
                onChange={(e) => setSessionTimeout(Number(e.target.value))}
                className="text-sm border border-[#eaeaec] rounded-lg px-3 py-1"
              >
                <option value="600">10 minutes</option>
                <option value="1800">30 minutes</option>
                <option value="3600">1 hour</option>
                <option value="7200">2 hours</option>
              </select>
            </div>
            <p className="text-xs text-[#94969f]">
              You'll be logged out after this period of inactivity
            </p>
          </div>
        </div>

        {/* Device Management */}
        <div className="mb-6">
          <div className="flex justify-between items-center mb-3">
            <h3 className="font-semibold text-[#282c3f] flex items-center gap-2">
              <Monitor size={20} className="text-[#ff3f6c]" />
              Active Devices
            </h3>
            <button
              onClick={logoutAllDevices}
              className="text-xs text-red-600 font-medium hover:underline"
            >
              Logout All
            </button>
          </div>
          <div className="space-y-2">
            {loginHistory.map((device) => (
              <div
                key={device.id}
                className="bg-gray-50 rounded p-4 border border-[#eaeaec]"
              >
                <div className="flex justify-between items-start mb-2">
                  <div className="flex items-start gap-3">
                    <Monitor size={20} className="text-[#94969f] mt-0.5" />
                    <div>
                      <p className="font-semibold text-[#282c3f] text-sm">
                        {device.device}
                        {device.current && (
                          <span className="ml-2 bg-[#e8f7f3] text-[#03a685] text-xs px-2 py-0.5 rounded-full">
                            Current
                          </span>
                        )}
                      </p>
                      <p className="text-xs text-[#535766]">{device.location}</p>
                      <p className="text-xs text-[#94969f]">IP: {device.ip}</p>
                      <p className="text-xs text-[#94969f]">{device.time}</p>
                    </div>
                  </div>
                  {!device.current && (
                    <button
                      onClick={() => logoutDevice(device.id)}
                      className="text-red-600 hover:bg-red-50 p-1 rounded"
                    >
                      <LogOut size={16} />
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Security Audit Logs */}
        <div className="mb-6">
          <h3 className="font-semibold text-[#282c3f] mb-3 flex items-center gap-2">
            <Activity size={20} className="text-[#03a685]" />
            Activity Log
          </h3>
          <div className="space-y-2 max-h-64 overflow-y-auto">
            {securityLogs.map((log) => (
              <div
                key={log.id}
                className={`bg-gray-50 rounded p-3 border-l-4 ${
                  log.type === 'success'
                    ? 'security-log-success'
                    : log.type === 'warning'
                    ? 'security-log-warning'
                    : 'security-log-info'
                }`}
              >
                <div className="flex items-start gap-2">
                  {log.type === 'success' && <Check size={16} className="text-[#03a685] mt-0.5" />}
                  {log.type === 'warning' && <AlertTriangle size={16} className="text-[#ff3f6c] mt-0.5" />}
                  {log.type === 'info' && <Activity size={16} className="text-[#ff3f6c] mt-0.5" />}
                  <div className="flex-1">
                    <p className="font-semibold text-[#282c3f] text-sm">{log.action}</p>
                    <p className="text-xs text-[#535766]">{log.detail}</p>
                    <p className="text-xs text-[#94969f] mt-1">{log.time}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Login History Export */}
        <div className="bg-[#fff8fa] border border-[#eaeaec] rounded p-4">
          <h4 className="font-semibold text-[#282c3f] text-sm mb-2">Need your login history?</h4>
          <p className="text-xs text-[#535766] mb-3">
            Download a complete report of all your account activity
          </p>
          <button className="bg-[#ff3f6c] text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-[#e03a60] transition-all w-full">
            Download Security Report
          </button>
        </div>
      </div>
    </div>
  );
    export default SecuritySettingsModal;